import {Button, Popover} from '@primer/react'
import {useCallback, useState} from 'react'

import {useUpdateUserDiffViewPreferenceMutation} from '../hooks/mutations/use-update-user-diff-view-preference-mutation'

import styles from './DiffCompactLinesPopover.module.css'
import {clsx} from 'clsx'

const NOTICE_NAME = 'compact_diff_lines'

type DiffCompactLinesPopoverProps = {
  useIsNoticeDismissed: (name: typeof NOTICE_NAME) => boolean
  useDismissNotice: (name: typeof NOTICE_NAME) => {dismissNotice: () => void}
}

export function DiffCompactLinesPopover({useIsNoticeDismissed, useDismissNotice}: DiffCompactLinesPopoverProps) {
  const isNoticeDismissed = useIsNoticeDismissed(NOTICE_NAME)
  const {dismissNotice} = useDismissNotice(NOTICE_NAME)
  const {mutate: updateUserDiffViewPreference} = useUpdateUserDiffViewPreferenceMutation({
    onSuccess: () => {},
    onError: () => {},
  })
  const [popoverOpen, setPopoverOpen] = useState(true)

  const onEnable = useCallback(() => {
    updateUserDiffViewPreference({lineSpacing: 'compact'})
    setPopoverOpen(false)
    dismissNotice()
  }, [dismissNotice, updateUserDiffViewPreference])

  const onDismiss = useCallback(() => {
    setPopoverOpen(false)
    dismissNotice()
  }, [dismissNotice])

  if (isNoticeDismissed) return null

  return (
    <Popover open={popoverOpen} caret="top-right" className={styles.PopoverContainer}>
      <Popover.Content className={clsx('d-flex flex-column gap-2', styles.PopoverContent)}>
        <h2 className={styles.Heading}>Customizable line height</h2>
        <p>
          The default line height has been increased for improved accessibility. You can choose to enable a more compact
          line height from the view settings menu.
        </p>
        <div className="d-flex gap-2 flex-row w-full flex-wrap">
          <Button onClick={onEnable}>Enable compact line height</Button>
          <Button onClick={onDismiss} variant="invisible">
            Dismiss
          </Button>
        </div>
      </Popover.Content>
    </Popover>
  )
}
